export const SelectArrow = () => (
  <svg width="8" height="5" viewBox="0 0 8 5" fill="none">
    <path
      d="M7 1.125L4 3.875L1 1.125"
      stroke="#01054C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const onlyDigits = (v) => (v || "").replace(/\D/g, "");

export const formatVolume = (v) => onlyDigits(v).slice(0, 9);

export const formatFullDate = (v) => {
  const d = onlyDigits(v).slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
};

export const formatCurrency = (v) => {
  const digits = onlyDigits(v);
  if (!digits) return "";
  const number = Number.parseInt(digits, 10) / 100;

  return number.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });
};

export const formatDias = (v) => onlyDigits(v).slice(0, 3);